import { VideoMetadata } from "@nova/slice-video"
import { useAppSelector } from "integrations/redux/hooks"
import { selectActiveSidePanelModal } from "panels/content/side-panel/slice"
import { selectActiveLayerId, selectSelectedLayerIds } from "panels/content/side-panel/slice.new"
import { useMemo } from "react"
import { ColorFinderState } from "./ImageColorFinderSlice"
import { isUsable } from "@nova/constants"
import { selectColorFinderImagesAndUploadsByFlightId } from "features/entity-caching/images/colorfinder/selectors"

export const useImageMetadata = () => {
    const activeSidePanelModalId = useAppSelector(selectActiveSidePanelModal())?.id
    const activeLayerId = useAppSelector(selectActiveLayerId)
    const selectedLayerId = useAppSelector(selectSelectedLayerIds).at(-1)
    const id = activeLayerId || activeSidePanelModalId || selectedLayerId || ""
    const uploads = useAppSelector(selectColorFinderImagesAndUploadsByFlightId(id))

    const imagesMetadata = useMemo(() => {
        const data: VideoMetadata = []

        const usableUploads: ColorFinderState[] = []
        uploads?.forEach((upload) => {
            const usableUpload = isUsable(upload) as ColorFinderState
            if (usableUpload) usableUploads.push(usableUpload)
        })

        usableUploads
            .sort((a, b) =>
                (a.takenAt || "") < (b.takenAt || "") ? -1 : a.takenAt === b.takenAt ? 0 : 1
            )
            .forEach((upload) => {
                if (upload.longitude) {
                    data.push([
                        upload.longitude,
                        upload.latitude ?? NaN,
                        upload.height ?? NaN,
                        upload.pitch ?? NaN,
                        upload.yaw ?? NaN,
                        upload.roll ?? NaN,
                        upload.fov ?? upload.focalLength ?? NaN,
                        upload.altitude ?? NaN,
                    ])
                }
            })

        return data.length > 0 ? data : undefined
    }, [uploads])

    return { imagesMetadata }
}
